export default __webpack_public_path__ + "static/hologram-4fb696a0c60943ef168161205e8cc46b.png";